<template>
  <div>
    <b-card>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">تاریخ مصاحبه</th>
            <th scope="col">تعداد</th>
            <th scope="col">(نام اتاق) 1</th>
            <th scope="col">(نام اتاق) 2</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in items" :key="i">
            <td v-show="item.date" :rowspan="item.count">{{ item.date }}</td>
            <td>{{ item.caption }}</td>
            <td>{{ item.num1.name }}</td>
            <td>{{ item.num2.name }}</td>
          </tr>
        </tbody>
      </table>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
      items: [],
      iteams: [
        {
          date: "1400/01/01",
          count: 2,
          caption: "استاد مصاحبه",
          num1: "2",
          num2: "3",
          num3: "0",
        },
        {
          date: null,
          count: null,
          caption: "استاد motaghazi",
          num1: "2",
          num2: "3",
          num3: "0",
        },
        {
          date: "1400/01/02",
          count: 3,
          caption: "استاد مصاحبه",
          num1: "2",
          num2: "3",
          num3: "0",
        },
        {
          caption: "استاد motaghazi",
          num1: "2",
          num2: "3",
          num3: "0",
        },
        {
          caption: "استاد motaghazi",
          num1: "2",
          num2: "3",
          num3: "0",
        },
      ],
    };
  },
  methods: {
    async fetchData() {
      try {
        const url =
          this.$config.api_url +
          this.$config.interview.interview_location_plan_id.replace(
            "{0}",
            this.id
          );
        const response = await this.$httpService.get(url);
        let data = response.data.data;
        let a = [];
        data.map((x) => {
          let count = x.length;
          return x.map((x, i) => {
            a.push({
              date: i == 0 ? x.date : null,
              count: i == 0 ? count : null,
              caption: i == 0 ? "استاد مصاحبه" : "متقاضی",
              num1: x.master.room,
              num2: x.audience.room,
            });
          });
        });
        this.items = a;
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
